import { useTranslation } from 'react-i18next'
import { useCheckout } from 'components/Checkout/CheckoutContext'
import {
  buildDiscountProgressProps,
  type DiscountProgressProps,
} from 'features/cart/discountProgressProps'
import { groupPricingToDiscountData } from 'features/cart/groupPricingToDiscountData'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'
import { SHIPPING_OPTION_FREE } from 'stores/shippingStore/shipping.consts'
import { useLastGroupPricing } from './useLastGroupPricing'

// Data for the stepped progress bar (styler pill and bag promo segment). The
// shipping goal participates only while free shipping is selected, mirroring
// useFreeShippingMessage.
export function useDiscountProgress(): DiscountProgressProps | null {
  const { t } = useTranslation()
  const { selectedShippingOptionName } = useCheckout()
  const experimentManager = useExperimentManager()
  const groupPricing = useLastGroupPricing()

  if (!groupPricing) return null
  const includeShipping = selectedShippingOptionName === SHIPPING_OPTION_FREE
  const data = groupPricingToDiscountData(groupPricing, includeShipping, () =>
    experimentManager.isEnabled('bundle-communication-v2')
  )

  return buildDiscountProgressProps(data, t)
}
